namespace $.$$ {

	$mol_style_define( $shm_hitalama_footer, {
		flex: {
			direction: 'column',
		},
		gap: '0.5rem',
		align: {
			items: 'center',
		},

		Label: {
			justify: {
				content: 'center',
			},
		},

		Logo: {
			width: '11rem',
			maxWidth: '100%',
		},

		Version: {
			width: '11rem',
			maxWidth: '100%',
			minWidth: 0,
			justify: {
				content: 'center',
			},
		},
	} )

}
